import Glide from "@glidejs/glide";
import useNcId from "hooks/useNcId";
import React, { FC, useEffect, useRef } from "react";
import NcImage from "shared/NcImage/NcImage";
import NextPrev from "shared/NextPrev/NextPrev";
import { Link } from "react-router-dom";

export interface ImageSliderProps {
  className?: string;
  galleryImgs: string[];
  ratioClass?: string;
  uniqueID: string;
  href?: string;
}

const ImageSlider: FC<ImageSliderProps> = ({
  className = "",
  galleryImgs,
  ratioClass = "aspect-w-4 aspect-h-3",
  uniqueID = "uniqueID",
  href = "/listing-stay-detail",
}) => {
  const UNIQUE_CLASS = `ImageSlider__${uniqueID}` + useNcId();

  const sliderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sliderElement = sliderRef.current;
    if (!sliderElement || !sliderElement.querySelector(".glide__track")) return;

    const glide = new Glide(sliderElement, {
      perView: 1,
      gap: 0,
      keyboard: false,
    });
    glide.mount();

    return () => {
      glide.destroy();
    };
  }, [galleryImgs]);


  const renderSliderGallery = () => {
    return (
      <div ref={sliderRef} className={`${UNIQUE_CLASS} relative group overflow-hidden`}>
        <div className="glide__track" data-glide-el="track">
       
            {galleryImgs.map((item, index) => (

                <Link key={uniqueID} to={href} className={`block ${ratioClass}`}>
                  <NcImage src={item} />
                </Link>

            ))}
  
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-GallerySlider ${className}`} data-nc-id="GallerySlider">
      {renderSliderGallery()}
    </div>
  );
};

export default ImageSlider;
